import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './CloseButton.scss';

const CloseButton = ({ onClose, title, isMobile }) => (
  <button className={cx(styles.btnWrapper, { [styles.mobile]: isMobile })} onClick={onClose} title={title}>
    <i className={cx('icon icon-close', styles.closeBtn)} />
  </button>
);

CloseButton.propTypes = {
  onClose: PropTypes.func,
  title: PropTypes.string,
  isMobile: PropTypes.bool
};

export default CloseButton;
